import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * PD-17646 — a personal booking link for one recipient (`?t=…`). It names the person, so
 * the page already knows who they are, and it is the proof of being invited when a
 * booking type is limited to people a link was sent to. Only the token's hash is stored.
 */
@Index('IDX_booking_invite_token', ['tokenHash'], { unique: true })
@Index('IDX_booking_invite_type', ['fkBookingTypeId'])
@Entity('booking_invite', {}, { auditRedactedProperties: ['tokenHash'] })
export class BookingInviteEntity extends BaseEntity {
	@Column('varchar', { name: 'tokenHash', length: 128 })
	public tokenHash!: string;

	@Column('int', { name: 'fk_booking_type__id', unsigned: true })
	public fkBookingTypeId!: number;

	@Column('int', { name: 'fk_contact__id', unsigned: true, nullable: true })
	public fkContactId!: number | null;

	@Column('int', { name: 'fk_client__id', unsigned: true, nullable: true })
	public fkClientId!: number | null;

	/** The campaign run this link came from, so a booking ends that run. */
	@Column('int', { name: 'fk_campaign_membership__id', unsigned: true, nullable: true })
	public fkCampaignMembershipId!: number | null;

	/** The email the link was sent to, for when no person is on file yet. */
	@Column('varchar', { name: 'email', length: 320, nullable: true })
	public email!: string | null;

	@Column('datetime', { name: 'expiresDate' })
	public expiresDate!: Date;
}
